// export const domain = `http://121.37.109.174:8086/`
// export const domain = `https://www.gaopaizc.com/images`
// export const domain = `http://${window.location.host}/imagesRaw`;
export const domain = `https://${window.location.host}/images`;
